<template>
  <div>
    <v-layout row wrap style="overflow:hidden;">
      <v-flex xs12 sm6 md3 class="banking">
        <a href="/spice-money-banking">
          <h2 title>Banking Services</h2>
          <p class="desc">Bridging the digital gap</p>
          <img
            class="abs-img"
            alt="Banking Services"
            width="100%"
            :src="require('@/assets/images/spice-money-bankingservices.png')"
          >
        </a>
      </v-flex>
      <v-flex xs12 sm6 md3 class="payment">
        <a href="/spice-money-payment">
          <h2 title>Payment Services</h2>
          <p class="desc">We provide payment solutions such as Aadhaar Pay, UPI & QR Scan</p>
          <img
            class="abs-img"
            width="100%"
            alt="Payment Services"
            :src="require('@/assets/images/spice-money-paymentservices.png')"
          >
        </a>
      </v-flex>
      <v-flex xs12 sm6 md3 class="travel">
        <a href="/spice-money-travel">
          <h2 title>Travel Services</h2>
          <p class="desc">Various travel services under one roof (Train tickets & flight booking )</p>
          <img
            class="abs-img"
            width="100%"
            alt="Travel Services"
            :src="require('@/assets/images/spice-money-travelservices.png')"
          >
        </a>
      </v-flex>
      <v-flex xs12 sm6 md3 class="mobile">
        <a href="/spice-money-recharge">
          <h2 title>Bill Pay / Recharges</h2>
          <p class="desc">One stop solution for all your recharges and bill payments</p>
          <img
            class="abs-img"
            width="100%"
            alt="Bill Payment & Recharges"
            :src="require('@/assets/images/spice-money-recharges.png')"
          >
        </a>
      </v-flex>
    </v-layout>

    <!-- <div class="footer">
          <div class="container" style="border-top: none; background: rgb(246, 246, 246);">
            <a target="_blank" href="/tnc" data-gatag="Terms &amp; Conditions"  class=" GATag">Terms &amp; Conditions</a> &nbsp; &nbsp; | &nbsp; &nbsp; 
            <a target="_blank" href="/privacyPolicy"  data-gatag="Privacy Policy"  class="GATag">Privacy Policy</a> &nbsp; &nbsp; | &nbsp; &nbsp; 
            <a target="_blank" href="/customerGrievance"  data-gatag="Customer Grievance"  class=" GATag">Customer Grievance</a>&nbsp; &nbsp; | &nbsp; &nbsp; 
            <a target="_blank" href="/faq"  data-gatag="FAQs"  class=" GATag">FAQs</a></div>
    </div>-->
    <v-dialog
      v-model="$store.state.detailModal"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <BankingDetails v-if="selectedModal=='banking'"></BankingDetails>
      <AgilityDetails v-if="selectedModal=='agility'"></AgilityDetails>
      <JobDetails v-if="selectedModal=='jobs'"></JobDetails>
      <PaymentDetails v-if="selectedModal=='payment'"></PaymentDetails>
      <TechnologyDetails v-if="selectedModal=='technology'"></TechnologyDetails>
      <TravelDetails v-if="selectedModal=='travel'"></TravelDetails>
      <RechargeDetails v-if="selectedModal=='recharge'"></RechargeDetails>
    </v-dialog>
  </div>
</template>

<style scoped>
a {
  text-decoration: none;
}
.banking {
  background: #fff9c2;
}
.payment {
  background: #f0f7ff;
}
.travel {
  background: #fff1de;
}
.mobile {
  background: #fafafa;
}
.banking,
.payment,
.travel,
.mobile {
  position: relative;
  transition: all ease-in-out 0.4s;
  cursor: pointer;
  min-height: 400px;
  padding: 24px 0 0;
  text-align: center;
}
.banking img,
.payment img,
.travel img,
.mobile img {
  bottom: 0;
  width: 100%;
  transition: all ease-in-out 0.4s;
}
.banking:hover img,
.payment:hover img,
.travel:hover img,
.mobile:hover img {
  /* transform: rotate(5deg); */
}
@media only screen and (min-width: 768px) {
  .banking:hover,
  .payment:hover,
  .travel:hover,
  .mobile:hover {
    -webkit-box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.15);
    transform: scale(1.05, 1.05);
    position: relative;
    z-index: 3;
  }
}
h2 {
  font-family: "Khand", sans-serif;
  font-size: 36px;
  padding: 0 24px;
  color: #293896;
  line-height: 45px;
  font-weight: normal;
}
.desc {
  font-size: 16px;
  font-style: italic;
  color: #343434;
  padding: 10px 24px 0;
  min-height: 60px;
  margin: 0;
}
.earn-now {
  position: relative;
  padding: 20px 90px;
  background: #2d2d2d;
  font-size: 42px;
  color: #fff;
  font-family: "Poppins", sans-serif;
  font-weight: bold;
}
.join-now {
  background: #ec1c25;
  padding: 0px 45px;
  height: 75px;
  line-height: 75px;
  text-transform: uppercase;
  color: #fff;
  display: inline-block;
  font-size: 30px;
  font-weight: 900;
  font-family: "Montserrat", sans-serif;
  text-decoration: none;
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.52);
  z-index: 2;
  transition: all ease-in-out 0.3s;
}

.join-now:hover {
  border-radius: 5px;
  -webkit-box-shadow: 5px 5px 6px 0px rgba(0, 0, 0, 0.67);
  box-shadow: 5px 5px 6px 0px rgba(0, 0, 0, 0.67);
}

@media only screen and (max-width: 768px) {
  .earn-now {
    position: relative;
    padding: 15px 20px;
    font-size: 22px;
  }
  .join-now {
    padding: 0px 25px;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    margin-top: 15px;
  }
  .v-dialog--fullscreen {
    padding: 50px 50px 0px 50px;
  }
}

.footer a {
  text-decoration: none;
  color: #424fa2;
}
.footer a:hover {
  color: #2e3ea8;
}
</style>

<script>
import Explore from "./Explore.ts";
export default Explore;
</script>